module.exports = __webpack_public_path__ + "static/media/eye-close.b32de420.svg";